import { createSelector } from '@ngrx/store';
import { getHistoryOrderStatus } from '../getHistoryOrderStatus';

export const isHistoryOrderPreparing = (orderGUID: string) =>
    createSelector(getHistoryOrderStatus(orderGUID), (status) => status === OLO.Enums.ONLINE_ORDER_STATUS.SENT_TO_KITCHEN);
